import { LogsList } from "../../components/LogsList";

const LogsPage = () => {
  return <LogsList />;
};

export default LogsPage;
